import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import SearchIcon from "@mui/icons-material/Search";
import { Box, Button, Chip, Grid, TextField } from "@mui/material";
import DropdownPicker from "../../../../../components/shared/dropdown";
import JalaliDatePicker from "../../../../../components/shared/jalali-datepicker";
import {
  INTERNAL_STATUS_OPTIONS,
  PROVIDER_STATUS_OPTIONS,
  SEND_STATUS_OPTIONS,
} from "./constants";

const QUICK_FILTERS = [
  { key: "today", label: "امروز" },
  { key: "yesterday", label: "دیروز" },
  { key: "last7", label: "۷ روز اخیر" },
  { key: "thisMonth", label: "ماه جاری" },
];

const SmsMonitoringFilters = ({
  filterValues,
  setFilterValues,
  smsTypes,
  onSearch,
  onReset,
  onQuickDate,
  loading,
}) => (
  <Box sx={{ mb: 3 }}>
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 2 }}>
      {QUICK_FILTERS.map((item) => (
        <Chip
          key={item.key}
          label={item.label}
          onClick={() => onQuickDate(item.key)}
          variant="outlined"
          clickable
        />
      ))}
    </Box>

    <Grid container spacing={2}>
      <Grid item xs={12} md={6} lg={3}>
        <TextField
          fullWidth
          size="small"
          label="شماره موبایل"
          value={filterValues.mobile}
          onChange={(e) => setFilterValues((p) => ({ ...p, mobile: e.target.value }))}
        />
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <TextField
          fullWidth
          size="small"
          label="شناسه پیام"
          value={filterValues.messageId}
          onChange={(e) => setFilterValues((p) => ({ ...p, messageId: e.target.value }))}
        />
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <TextField
          fullWidth
          size="small"
          label="شناسه درخواست"
          value={filterValues.requestId}
          onChange={(e) => setFilterValues((p) => ({ ...p, requestId: e.target.value }))}
        />
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <TextField
          fullWidth
          size="small"
          label="شماره پیگیری"
          value={filterValues.referenceId}
          onChange={(e) => setFilterValues((p) => ({ ...p, referenceId: e.target.value }))}
        />
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <DropdownPicker
          label="نوع پیامک"
          value={filterValues.smsType}
          onChange={(e) => setFilterValues((p) => ({ ...p, smsType: e.target.value }))}
          list={[{ name: "همه", value: "" }, ...smsTypes.map((t) => ({ name: t.label, value: t.key }))]}
          optionName="name"
          optionValue="value"
          filterable={smsTypes.length > 8}
          size="small"
        />
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <TextField
          fullWidth
          size="small"
          label="هدف ارسال"
          value={filterValues.purpose}
          onChange={(e) => setFilterValues((p) => ({ ...p, purpose: e.target.value }))}
        />
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <DropdownPicker
          label="وضعیت داخلی"
          value={filterValues.internalStatus}
          onChange={(e) => setFilterValues((p) => ({ ...p, internalStatus: e.target.value }))}
          list={INTERNAL_STATUS_OPTIONS.map((o) => ({ name: o.label, value: o.value }))}
          optionName="name"
          optionValue="value"
          size="small"
        />
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <DropdownPicker
          label="وضعیت سرویس‌دهنده"
          value={filterValues.providerStatus}
          onChange={(e) => setFilterValues((p) => ({ ...p, providerStatus: e.target.value }))}
          list={PROVIDER_STATUS_OPTIONS.map((o) => ({ name: o.label, value: o.value }))}
          optionName="name"
          optionValue="value"
          size="small"
        />
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <DropdownPicker
          label="وضعیت ارسال (سیستمی)"
          value={filterValues.status}
          onChange={(e) => setFilterValues((p) => ({ ...p, status: e.target.value }))}
          list={SEND_STATUS_OPTIONS.map((o) => ({ name: o.label, value: o.value }))}
          optionName="name"
          optionValue="value"
          size="small"
        />
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <TextField
          fullWidth
          size="small"
          label="حداقل هزینه"
          type="number"
          value={filterValues.minCost}
          onChange={(e) => setFilterValues((p) => ({ ...p, minCost: e.target.value }))}
        />
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <TextField
          fullWidth
          size="small"
          label="حداکثر هزینه"
          type="number"
          value={filterValues.maxCost}
          onChange={(e) => setFilterValues((p) => ({ ...p, maxCost: e.target.value }))}
        />
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <JalaliDatePicker
          label="تاریخ شروع"
          fullWidth
          size="small"
          value={filterValues.startDate}
          onChange={(value) => setFilterValues((p) => ({ ...p, startDate: value || "" }))}
        />
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <JalaliDatePicker
          label="تاریخ پایان"
          fullWidth
          size="small"
          value={filterValues.endDate}
          onChange={(value) => setFilterValues((p) => ({ ...p, endDate: value || "" }))}
        />
      </Grid>
      <Grid item xs={12}>
        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
          <Button variant="contained" startIcon={<SearchIcon />} onClick={onSearch} disabled={loading}>
            جستجو
          </Button>
          <Button variant="text" startIcon={<HighlightOffIcon />} onClick={onReset} disabled={loading}>
            بازنشانی فیلترها
          </Button>
        </Box>
      </Grid>
    </Grid>
  </Box>
);

export default SmsMonitoringFilters;
